import { render, staticRenderFns } from "./footEdit.vue?vue&type=template&id=67f0205d&scoped=true&"
import script from "./footEdit.vue?vue&type=script&lang=js&"
export * from "./footEdit.vue?vue&type=script&lang=js&"
import style0 from "./footEdit.vue?vue&type=style&index=0&id=67f0205d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0205d",
  null
  
)

export default component.exports